import { render, staticRenderFns } from "./AthleteReport.vue?vue&type=template&id=cbe7c3b8&"
import script from "./AthleteReport.vue?vue&type=script&lang=ts&"
export * from "./AthleteReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports